@let customFieldFormGroupValue = customFieldFormGroup();
@let isReadOnlyValue = isReadOnly();
@let hideRequiredBadgesValue = hideRequiredBadges();
@let errorMessagesVisibleValue = errorMessagesVisible();
@let isTranslationMarkedValue = isTranslationMarked();
@let isPrimaryLangValue = isPrimaryLang();

@switch (customFieldFormGroupValue.value.type) {
  @case (CustomFieldType.SingleLine) {
    <ng-container
      *ngTemplateOutlet="
        singleFieldTemplate;
        context: { customFieldFormGroup: customFieldFormGroupValue }
      "
    />
  }
  @case (CustomFieldType.SingleChoice) {
    <ng-container
      *ngTemplateOutlet="
        singleChoiceTemplate;
        context: { customFieldFormGroup: customFieldFormGroupValue }
      "
    />
  }
  @case (CustomFieldType.MultiChoice) {
    <ng-container
      *ngTemplateOutlet="
        multiChoiceTemplate;
        context: { customFieldFormGroup: customFieldFormGroupValue }
      "
    />
  }
  @case (CustomFieldType.Boolean) {
    <ng-container
      *ngTemplateOutlet="
        booleanTemplate;
        context: { customFieldFormGroup: customFieldFormGroupValue }
      "
    />
  }
  @case (CustomFieldType.Number) {
    <ng-container
      *ngTemplateOutlet="
        numberTemplate;
        context: { customFieldFormGroup: customFieldFormGroupValue }
      "
    />
  }
  @case (CustomFieldType.Money) {
    <ng-container
      *ngTemplateOutlet="
        moneyTemplate;
        context: { customFieldFormGroup: customFieldFormGroupValue }
      "
    />
  }
  @case (CustomFieldType.Date) {
    <ng-container
      *ngTemplateOutlet="dateTemplate; context: { customFieldFormGroup: customFieldFormGroupValue }"
    />
  }
  @case (CustomFieldType.SingleUser) {
    <ng-container
      *ngTemplateOutlet="
        singleUserTemplate;
        context: { customFieldFormGroup: customFieldFormGroupValue }
      "
    />
  }
  @case (CustomFieldType.MultiUser) {
    <ng-container
      *ngTemplateOutlet="
        multiUserTemplate;
        context: { customFieldFormGroup: customFieldFormGroupValue }
      "
    />
  }
}

<ng-template
  #singleFieldTemplate
  let-customFieldFormGroup="customFieldFormGroup"
  [ngTemplateType]="singleLineContextType"
>
  <rt-form-field [hasLabelMargin]="false">
    <ng-container
      *ngTemplateOutlet="
        labelTpl;
        context: {
          required:
            isPrimaryLangValue &&
            customFieldFormGroup.controls.required.value &&
            !customFieldFormGroup.controls.value.controls.value.value?.trim() &&
            !isReadOnlyValue &&
            !hideRequiredBadgesValue,
        }
      "
    />

    <rt-input
      variant="rounded"
      [formControl]="customFieldFormGroup.controls.value.controls.value"
      [placeholder]="'app.custom_fields.value_placeholder' | translate"
      [rtProtectedControl]="customFieldFormGroup.controls.value.controls.value"
      [readOnly]="isReadOnlyValue"
      [class.yellow]="isTranslationMarkedValue"
    />
    @if (
      (customFieldFormGroup.controls.value.controls.value.errors?.required ||
        customFieldFormGroup.controls.value.controls.value.errors?.whitespace) &&
      errorMessagesVisibleValue
    ) {
      <span text-red padding-top-small-xx>{{
        'app.offer_form.errors_new_validation.custom_fields.required' | translate
      }}</span>
    }
  </rt-form-field>
</ng-template>

<ng-template
  #singleChoiceTemplate
  let-customFieldFormGroup="customFieldFormGroup"
  [ngTemplateType]="singleChoiceContextType"
>
  <rt-form-field [hasLabelMargin]="false">
    <ng-container
      *ngTemplateOutlet="
        labelTpl;
        context: {
          required:
            customFieldFormGroup.controls.required.value &&
            !customFieldFormGroup.controls.value.controls.option.value &&
            !isReadOnlyValue &&
            !hideRequiredBadgesValue,
        }
      "
    />
    <rt-select
      [options]="selectOptions()"
      [placeholder]="'app.common.select' | translate"
      [formControl]="customFieldFormGroup.controls.value.controls.option"
      [rtProtectedControl]="customFieldFormGroup.controls.value.controls.option"
      [hasClearButton]="true"
      [hasInputTrigger]="true"
      [isInvalid]="hasControlError(customFieldFormGroup.controls.value.controls.option)"
      [readOnly]="isReadOnlyValue"
    >
      <ng-template let-item="item">
        <strong>{{ item.option }}</strong>
      </ng-template>
    </rt-select>
    @if (
      customFieldFormGroup.controls.value.controls.option.errors?.required &&
      errorMessagesVisibleValue
    ) {
      <span text-red padding-top-small-xx>{{
        'app.offer_form.errors_new_validation.custom_fields.required' | translate
      }}</span>
    }
  </rt-form-field>
</ng-template>

<ng-template
  #multiChoiceTemplate
  let-customFieldFormGroup="customFieldFormGroup"
  [ngTemplateType]="multiChoiceContextType"
>
  <rt-form-field [hasLabelMargin]="false">
    <ng-container
      *ngTemplateOutlet="
        labelTpl;
        context: {
          required:
            customFieldFormGroup.controls.required.value &&
            !customFieldFormGroup.controls.value.controls.options.value?.length &&
            !isReadOnlyValue &&
            !hideRequiredBadgesValue,
        }
      "
    />
    <rt-multi-select-custom-field
      [control]="customFieldFormGroup.controls.value.controls.options"
      [selectOptions]="selectOptions()"
      [isInvalid]="hasControlError(customFieldFormGroup.controls.value.controls.options)"
      [isReadOnly]="isReadOnlyValue"
    />
    @if (
      customFieldFormGroup.controls.value.controls.options.errors?.required &&
      errorMessagesVisibleValue
    ) {
      <span text-red padding-top-small-xx>{{
        'app.offer_form.errors_new_validation.custom_fields.required' | translate
      }}</span>
    }
  </rt-form-field>
</ng-template>

<ng-template
  #booleanTemplate
  let-customFieldFormGroup="customFieldFormGroup"
  [ngTemplateType]="booleanContextType"
>
  <rt-form-field [hasLabelMargin]="false">
    <ng-container
      *ngTemplateOutlet="
        labelTpl;
        context: {
          required:
            customFieldFormGroup.controls.required.value &&
            !customFieldFormGroup.controls.value.controls.value.value?.toString() &&
            !isReadOnlyValue &&
            !hideRequiredBadgesValue,
        }
      "
    />
    <rt-toggle
      [formControl]="customFieldFormGroup.controls.value.controls.value"
      [rtProtectedControl]="customFieldFormGroup.controls.value.controls.value"
      [disabled]="isReadOnlyValue"
    >
      {{ customFieldFormGroup.value.value?.value ? translations.yes : translations.no }}
    </rt-toggle>
    @if (
      customFieldFormGroup.controls.value.controls.value.errors?.required &&
      errorMessagesVisibleValue
    ) {
      <span text-red padding-top-small-xx>{{
        'app.offer_form.errors_new_validation.custom_fields.required' | translate
      }}</span>
    }
  </rt-form-field>
</ng-template>

<ng-template
  #numberTemplate
  let-customFieldFormGroup="customFieldFormGroup"
  [ngTemplateType]="numberContextType"
>
  @if (customFieldFormGroup.value.configuration?.isRange) {
    <rt-form-field [hasLabelMargin]="false">
      <ng-container
        *ngTemplateOutlet="
          labelTpl;
          context: {
            required:
              customFieldFormGroup.controls.required.value &&
              !(
                customFieldFormGroup.controls.value.controls.min?.value?.toString()?.trim() &&
                customFieldFormGroup.controls.value.controls.max?.value?.toString()?.trim()
              ) &&
              !isReadOnlyValue &&
              !hideRequiredBadgesValue,
          }
        "
      />
      <div layout layout-align-items-center>
        <rt-numeric-input
          [formControl]="customFieldFormGroup.controls.value.controls.min!"
          [rtProtectedControl]="customFieldFormGroup.controls.value.controls.min!"
          [placeholder]="translations.min"
          [readOnly]="isReadOnlyValue"
          [displayLocaleFormatting]="false"
          layout-full-width
        />
        <span padding-lr-small-x>{{ 'app.offer_form.to' | translate }}</span>
        <rt-numeric-input
          [formControl]="customFieldFormGroup.controls.value.controls.max!"
          [rtProtectedControl]="customFieldFormGroup.controls.value.controls.max!"
          [placeholder]="translations.max"
          [readOnly]="isReadOnlyValue"
          [displayLocaleFormatting]="false"
          layout-full-width
        />
      </div>
      @if (errorMessagesVisibleValue) {
        <ng-container
          *ngTemplateOutlet="
            numberRangeErrorMessages;
            context: { customFieldFormGroup: customFieldFormGroupValue }
          "
        />
      }
    </rt-form-field>
  } @else {
    <rt-form-field [hasLabelMargin]="false">
      <ng-container
        *ngTemplateOutlet="
          labelTpl;
          context: {
            required:
              customFieldFormGroup.controls.required.value &&
              !customFieldFormGroup.controls.value.controls.value?.value?.toString()?.trim() &&
              !isReadOnlyValue &&
              !hideRequiredBadgesValue,
          }
        "
      />
      <rt-numeric-input
        [formControl]="customFieldFormGroup.controls.value.controls.value!"
        [rtProtectedControl]="customFieldFormGroup.controls.value.controls.value"
        [readOnly]="isReadOnlyValue"
        [displayLocaleFormatting]="false"
      />
      @if (errorMessagesVisibleValue) {
        <ng-container
          *ngTemplateOutlet="
            numberErrorMessages;
            context: { customFieldFormGroup: customFieldFormGroupValue }
          "
        />
      }
    </rt-form-field>
  }
</ng-template>

<ng-template
  #moneyTemplate
  let-customFieldFormGroup="customFieldFormGroup"
  [ngTemplateType]="moneyContextType"
>
  <div class="double-field">
    @if (customFieldFormGroup.value.configuration?.isRange) {
      <rt-form-field [hasLabelMargin]="false">
        <ng-container
          *ngTemplateOutlet="
            labelTpl;
            context: {
              required:
                customFieldFormGroup.controls.required.value &&
                !(
                  customFieldFormGroup.controls.value.controls.min?.value?.toString()?.trim() &&
                  customFieldFormGroup.controls.value.controls.max?.value?.toString()?.trim() &&
                  customFieldFormGroup.controls.value.controls.currency?.value
                ) &&
                !isReadOnlyValue &&
                !hideRequiredBadgesValue,
            }
          "
        />
        <div layout layout-align-items-center>
          <rt-numeric-input
            [formControl]="customFieldFormGroup.controls.value.controls.min!"
            [rtProtectedControl]="customFieldFormGroup.controls.value.controls.min!"
            [placeholder]="translations.min"
            [readOnly]="isReadOnlyValue"
            layout-full-with
          />
          <span padding-lr-small-x>{{ 'app.offer_form.to' | translate }}</span>
          <rt-numeric-input
            [formControl]="customFieldFormGroup.controls.value.controls.max!"
            [rtProtectedControl]="customFieldFormGroup.controls.value.controls.max!"
            [placeholder]="translations.max"
            [readOnly]="isReadOnlyValue"
            layout-full-with
          />
        </div>
        @if (errorMessagesVisibleValue) {
          <ng-container
            *ngTemplateOutlet="
              numberRangeErrorMessages;
              context: { customFieldFormGroup: customFieldFormGroupValue }
            "
          />
        }
      </rt-form-field>
    } @else {
      <rt-form-field [hasLabelMargin]="false">
        <ng-container
          *ngTemplateOutlet="
            labelTpl;
            context: {
              required:
                customFieldFormGroup.controls.required.value &&
                !(
                  customFieldFormGroup.controls.value.controls.value?.value?.toString()?.trim() &&
                  customFieldFormGroup.controls.value.controls.currency?.value
                ) &&
                !isReadOnlyValue &&
                !hideRequiredBadgesValue,
            }
          "
        />
        <rt-numeric-input
          [formControl]="customFieldFormGroup.controls.value.controls.value!"
          [rtProtectedControl]="customFieldFormGroup.controls.value.controls.value"
          [readOnly]="isReadOnlyValue"
        />
        @if (errorMessagesVisibleValue) {
          <ng-container
            *ngTemplateOutlet="
              numberErrorMessages;
              context: { customFieldFormGroup: customFieldFormGroupValue }
            "
          />
        }
      </rt-form-field>
    }

    <rt-form-field [hasLabelMargin]="false" padding-top-large margin-top-small-xx>
      <rt-currency-select-field
        [form]="customFieldFormGroup.controls.value.controls.currency"
        [hasClearButton]="true"
        [placeholder]="'app.offer_form.currency_placeholder' | translate"
        [isReadOnly]="isReadOnlyValue"
        [isInvalid]="hasControlError(customFieldFormGroup.controls.value.controls.currency)"
      />
      @if (
        (customFieldFormGroup.controls.value.controls.currency?.errors?.required ||
          customFieldFormGroup.controls.value.controls.currency?.errors?.whitespace) &&
        errorMessagesVisibleValue
      ) {
        <span text-red padding-top-small-xx>{{
          'app.offer_form.errors_new_validation.custom_fields.required' | translate
        }}</span>
      }
    </rt-form-field>
  </div>
</ng-template>

<ng-template
  #dateTemplate
  let-customFieldFormGroup="customFieldFormGroup"
  [ngTemplateType]="dateContextType"
>
  <rt-form-field [hasLabelMargin]="false">
    <ng-container
      *ngTemplateOutlet="
        labelTpl;
        context: {
          required:
            customFieldFormGroup.controls.required.value &&
            !customFieldFormGroup.controls.value.controls.value.value?.trim() &&
            !isReadOnlyValue &&
            !hideRequiredBadgesValue,
        }
      "
    />
    <rt-input
      #dateDropdownOrigin="rtOverlayOrigin"
      variant="rounded"
      rt-overlay-origin
      [value]="getSelectedDate(customFieldFormGroup.controls.value.controls.value.value)"
      [hasDropdownIndicator]="!isReadOnlyValue"
      [readOnly]="true"
      [disabled]="isReadOnlyValue"
      [placeholder]="'app.common.select' | translate"
      [invalid]="hasControlError(customFieldFormGroup.controls.value.controls.value)"
      (click)="dateDropdown.open = !dateDropdown.open"
    >
      <rt-icon prefix name="calendar-blank" />
    </rt-input>
    @if (
      customFieldFormGroup.controls.value.controls.value?.errors?.required &&
      errorMessagesVisibleValue
    ) {
      <span text-red padding-top-small-xx>{{
        'app.offer_form.errors_new_validation.custom_fields.required' | translate
      }}</span>
    }
  </rt-form-field>
  <ng-template
    [origin]="dateDropdownOrigin"
    (backdropClick)="dateDropdown.open = false"
    #dateDropdown="rtConnectedOverlay"
    rt-connected-overlay
    hasBackdrop
  >
    <rt-dropdown (click)="$event.stopPropagation()">
      <rt-dropdown-header>
        {{ 'app.candidate.select_date' | translate }}
      </rt-dropdown-header>
      <rt-date-picker
        [formControl]="customFieldFormGroup.controls.value.controls.value"
        (valueChanged)="dateDropdown.open = false"
      />
      @if (customFieldFormGroup.controls.value.controls.value.value) {
        <div layout layout-justify-center layout-align-items-center>
          <div margin-tb-medium>
            <rt-button
              variant="plain"
              (click)="clearDate(); dateDropdown.open = false"
              layout-full-width
            >
              <rt-icon name="close" />
              <span class="label"> {{ 'app.common.clear' | translate }}</span>
            </rt-button>
          </div>
        </div>
      }
    </rt-dropdown>
  </ng-template>
</ng-template>

<ng-template
  #singleUserTemplate
  let-customFieldFormGroup="customFieldFormGroup"
  [ngTemplateType]="singleUserContextType"
>
  <rt-user-select-container
    [label]="customFieldFormGroup.value.name!"
    [control]="customFieldFormGroup.controls.value.controls.admin"
    [filterByRoleIds]="
      customFieldFormGroup.controls.configuration.value.roles?.length
        ? customFieldFormGroup.controls.configuration.value.roles
        : undefined
    "
    [filterByUserIds]="
      customFieldFormGroup.controls.configuration.value.admins?.length
        ? customFieldFormGroup.controls.configuration.value.admins
        : undefined
    "
    [isReadOnly]="isReadOnlyValue"
    [labelMaxWidth]="270"
    [isInvalid]="hasControlError(customFieldFormGroup.controls.value.controls.admin)"
    [isRequired]="
      customFieldFormGroup.controls.required.value &&
      !customFieldFormGroup.controls.value.controls.admin.value &&
      !isReadOnlyValue &&
      !hideRequiredBadgesValue
    "
    [errors]="
      errorMessagesVisibleValue
        ? {
            required: 'app.offer_form.errors_new_validation.custom_fields.required' | translate,
          }
        : {}
    "
    [iconHelpTooltip]="iconHelpTooltip"
    (valueChange)="setSingleUserValue($event)"
  />
</ng-template>

<ng-template
  #multiUserTemplate
  let-customFieldFormGroup="customFieldFormGroup"
  [ngTemplateType]="multiUserContextType"
>
  <rt-form-field [hasLabelMargin]="false">
    <ng-container
      *ngTemplateOutlet="
        labelTpl;
        context: {
          required:
            customFieldFormGroup.controls.required.value &&
            !customFieldFormGroup.controls.value.controls.admins.value?.length &&
            !isReadOnlyValue &&
            !hideRequiredBadgesValue,
          helpIconText: iconHelpTooltip,
        }
      "
    />
    <rt-multi-user-custom-field-container
      [control]="customFieldFormGroup.controls.value.controls.admins"
      [configuration]="customFieldFormGroup.value.configuration"
      [isReadOnly]="isReadOnlyValue"
      [isInvalid]="hasControlError(customFieldFormGroup.controls.value.controls.admins)"
    />
    @if (
      customFieldFormGroup.controls.value.controls.admins?.errors?.required &&
      errorMessagesVisibleValue
    ) {
      <span text-red padding-top-small-xx>{{
        'app.offer_form.errors_new_validation.custom_fields.required' | translate
      }}</span>
    }
  </rt-form-field>
</ng-template>

<ng-template #labelTpl let-required="required" let-helpIconText="helpIconText">
  <rt-label [hasRequiredBadge]="required" margin-bottom-small-xx>
    <span
      [rtTooltip]="customFieldFormGroupValue.value.name"
      [rtTooltipEnableWhenTruncated]="true"
      class="label"
    >
      {{ customFieldFormGroupValue.value.name }}
    </span>
    @if (helpIconText) {
      <rt-icon-help [rtTooltip]="helpIconText" margin-left-small-x />
    }
    @if (
      customFieldsViewContext() === CustomFieldViewContext.Requisition &&
      !customFieldFormGroupValue.value.assignToOffer &&
      customFieldFormGroupValue.value.assignToRequisition
    ) {
      <rt-requisition-only-icon label-content-slot margin-left-small-x />
    }
  </rt-label>
</ng-template>

<ng-template #numberRangeErrorMessages let-customFieldFormGroup="customFieldFormGroup">
  @if (
    customFieldFormGroup.controls.value.controls.min?.errors?.notNumber ||
    customFieldFormGroup.controls.value.controls.max?.errors?.notNumber
  ) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.custom_fields.not_number' | translate
    }}</span>
  } @else if (
    customFieldFormGroup.controls.value.controls.min?.errors?.notGreaterThanOrEqualToZero ||
    customFieldFormGroup.controls.value.controls.max?.errors?.notGreaterThanOrEqualToZero
  ) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.custom_fields.not_grater_than_or_equal_zero' | translate
    }}</span>
  } @else if (
    customFieldFormGroup.controls.value.controls.min?.errors?.range ||
    customFieldFormGroup.controls.value.controls.max?.errors?.range
  ) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.custom_fields.range' | translate
    }}</span>
  } @else if (
    customFieldFormGroup.controls.value.controls.min?.errors?.required ||
    customFieldFormGroup.controls.value.controls.min?.errors?.whitespace ||
    customFieldFormGroup.controls.value.controls.max?.errors?.required ||
    customFieldFormGroup.controls.value.controls.max?.errors?.whitespace
  ) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.custom_fields.required' | translate
    }}</span>
  }
</ng-template>

<ng-template #numberErrorMessages let-customFieldFormGroup="customFieldFormGroup">
  @if (customFieldFormGroup.controls.value.controls.value?.errors?.notNumber) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.custom_fields.not_number' | translate
    }}</span>
  } @else if (
    customFieldFormGroup.controls.value.controls.value?.errors?.notGreaterThanOrEqualToZero
  ) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.custom_fields.not_grater_than_or_equal_zero' | translate
    }}</span>
  } @else if (
    customFieldFormGroup.controls.value.controls.value?.errors?.required ||
    customFieldFormGroup.controls.value.controls.value?.errors?.whitespace
  ) {
    <span text-red padding-top-small-xx>{{
      'app.offer_form.errors_new_validation.custom_fields.required' | translate
    }}</span>
  }
</ng-template>
